import React from "react";

type Props = {
    fetchedAt: number | null;
    sourceAsOf: number | null;
    stale: boolean;
};

const absent = "—";

const formatter = new Intl.DateTimeFormat("es-ES", {
    timeZone: "Europe/Madrid",
    dateStyle: "short",
    timeStyle: "medium",
});

const Stamp: React.FC<{ label: string; at: number | null; hint: string }> = ({ label, at, hint }) => (
    <span className="daily-freshness__item">
        <span className="daily-freshness__label">{label}</span>
        {at === null ? (
            <span className="daily-freshness__value">{absent}</span>
        ) : (
            <time className="daily-freshness__value" dateTime={new Date(at).toISOString()} title={hint}>
                {formatter.format(new Date(at))}
            </time>
        )}
    </span>
);

/**
 * FR-009: `fetchedAt` (when this browser asked) and `sourceAsOf` (when the evidence
 * was produced) are shown as two separate facts. Collapsing them would let a screen
 * present a refresh of a frozen source as fresh data.
 */
export const FreshnessBadge: React.FC<Props> = ({ fetchedAt, sourceAsOf, stale }) => (
    <span className={`daily-freshness${stale ? " daily-freshness--stale" : ""}`}>
        <Stamp label="Consulta realizada" at={fetchedAt} hint="Cuándo pidió esta página los datos por última vez" />
        <Stamp label="Evidencia de" at={sourceAsOf} hint="Cuándo produjo evidencia la fuente por última vez" />
        {stale ? <span className="daily-freshness__flag daily-sourcebar__flag">Datos atrasados</span> : null}
    </span>
);
